export enum BookingDetailsTabs {
  STATUS_UPDATES = 'status',
  ORDER_DETAILS = 'order',
  COMPLETED_BOOKING = 'completed'
}

export enum BookingsListTabs {
  ALL = 'all',
  UPCOMING = 'upcoming',
  PREVIOUS = 'previous'
}

export enum TireOfferTabs {
  STATUS_UPDATES = 'status-updates',
  ORDER_DETAILS = 'order-details'
}
